import {
  EMPTY_APP_STATE,
  type AppState,
  type CookingLocationId,
  type FoodTypeId,
} from "../domain/types";
import { normalizeAppState } from "./urlState";

export type AppAction =
  | { type: "toggle-food-type"; id: FoodTypeId }
  | { type: "toggle-cooking-location"; id: CookingLocationId }
  | { type: "toggle-ingredient"; id: string }
  | { type: "set-vegan-only"; value: boolean }
  | { type: "open-recipe"; id: string }
  | { type: "close-recipe" }
  | { type: "set-swap"; slotId: string; ingredientId: string }
  | { type: "clear" }
  | { type: "replace"; state: AppState };

function resetRecipe(state: AppState): AppState {
  return { ...state, recipeId: null, swaps: {} };
}

export function appReducer(state: AppState, action: AppAction): AppState {
  switch (action.type) {
    case "toggle-food-type": {
      const hasFoodType = state.foodTypeIds.includes(action.id);
      const foodTypeIds = hasFoodType
        ? state.foodTypeIds.filter((id) => id !== action.id)
        : [...state.foodTypeIds, action.id].sort();
      return resetRecipe({ ...state, foodTypeIds });
    }
    case "toggle-cooking-location": {
      const hasCookingLocation = state.cookingLocationIds.includes(action.id);
      const cookingLocationIds = hasCookingLocation
        ? state.cookingLocationIds.filter((id) => id !== action.id)
        : [...state.cookingLocationIds, action.id].sort();
      return resetRecipe({ ...state, cookingLocationIds });
    }
    case "toggle-ingredient": {
      const hasIngredient = state.ingredientIds.includes(action.id);
      const ingredientIds = hasIngredient
        ? state.ingredientIds.filter((id) => id !== action.id)
        : [...state.ingredientIds, action.id].sort();
      return resetRecipe({ ...state, ingredientIds });
    }
    case "set-vegan-only":
      return resetRecipe({ ...state, veganOnly: action.value });
    case "open-recipe":
      return normalizeAppState({ ...state, recipeId: action.id, swaps: {} });
    case "close-recipe":
      return { ...state, recipeId: null, swaps: {} };
    case "set-swap":
      return normalizeAppState({
        ...state,
        swaps: { ...state.swaps, [action.slotId]: action.ingredientId },
      });
    case "clear":
      return { ...EMPTY_APP_STATE };
    case "replace":
      return normalizeAppState(action.state);
  }
}
